import {combineReducers} from '@reduxjs/toolkit';

import {userRoleAuditLogStateSlice} from './slices/user-role-audit-log-state.slice';
import {userRoleAuditLogSlice} from './slices/user-role-audit-log.slice';

export const userRoleAuditLogReducer = combineReducers({
    result: userRoleAuditLogSlice.reducer,
    state: userRoleAuditLogStateSlice.reducer,
});
